"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tabs_exports = {};
__export(Tabs_exports, {
  Tabs: () => Tabs,
  default: () => Tabs_default
});
module.exports = __toCommonJS(Tabs_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_bottom_tabs = require("@react-navigation/bottom-tabs");
var import_react = __toESM(require("react"), 1);
var import_react_native = require("react-native");
var import_Link = require("../link/Link");
var import_Protected = require("../views/Protected");
var import_withLayoutContext = require("./withLayoutContext");
var DefaultTabBar = function(param) {
  var { state, ...restProps } = param;
  var filteredRoutes = state.routes.filter(function(r) {
    return r.name !== "+not-found" && !r.name.startsWith("_sitemap");
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_bottom_tabs.BottomTabBar, {
    state: {
      ...state,
      routes: filteredRoutes
    },
    ...restProps
  });
};
var BottomTabNavigator = (0, import_bottom_tabs.createBottomTabNavigator)().Navigator;
var RNTabs = (0, import_withLayoutContext.withLayoutContext)(BottomTabNavigator, function(screens) {
  return screens.map(function(screen) {
    var _screen_options;
    if (typeof screen.options !== "function" && ((_screen_options = screen.options) === null || _screen_options === void 0 ? void 0 : _screen_options.href) !== void 0) {
      var { href, ...options } = screen.options;
      if (options.tabBarButton) {
        throw new Error("Cannot use `href` and `tabBarButton` together.");
      }
      return {
        ...screen,
        options: {
          ...options,
          tabBarButton: function(props) {
            if (href == null) {
              return null;
            }
            var children = import_react_native.Platform.OS === "web" ? props.children : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.Pressable, {
              children: props.children
            });
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Link.Link, {
              ...props,
              style: [
                {
                  display: "flex"
                },
                props.style
              ],
              href,
              asChild: import_react_native.Platform.OS !== "web",
              // biome-ignore lint/correctness/noChildrenProp: children prop needed for asChild pattern
              children
            });
          }
        }
      };
    }
    return screen;
  });
});
var TabsWithRender = /* @__PURE__ */ import_react.default.forwardRef(function(props, ref) {
  var { tabBar, ...rest } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RNTabs, {
    ...rest,
    ref,
    tabBar: tabBar !== null && tabBar !== void 0 ? tabBar : DefaultTabBar
  });
});
var Tabs = Object.assign(TabsWithRender, {
  Protected: import_Protected.Protected,
  // Preserve withLayoutContext's static Screen so user code like
  // `<Tabs.Screen ... />` keeps working through the render wrapper.
  Screen: RNTabs.Screen
});
var Tabs_default = Tabs;
//# sourceMappingURL=Tabs.js.map
